import { useForm } from 'react-hook-form';

export type WordReplaceForm = {
  findText: string;
  replaceText: string;
};

const useWordReplaceForm = () => {
  return useForm<WordReplaceForm>({
    defaultValues: {
      findText: '',
      replaceText: '',
    },
    mode: 'onChange',
  });
};

export default useWordReplaceForm;
